import { useContext, useEffect, useState } from "react";
import { getBatch, getSortedCollection, matchQuery } from "sprint-common-web";

import { WatermarkRuleContext } from "../context/WatermarkRuleContext";
import { WatermarkRuleListingFilters } from "./useWatermarkRuleListingFilters";
import { WatermarkRuleItem } from "./WatermarkRuleItem";

export const useWatermarkRuleListing = (filters: WatermarkRuleListingFilters) => {
    const [items, setItems] = useState<WatermarkRuleItem[]>([]);
    const [totalItems, setTotalItems] = useState<number>(0);

    const { watermarkRuleItems, isLoading } = useContext(WatermarkRuleContext);

    useEffect(() => {
        saveData();
    }, [filters, watermarkRuleItems]);

    const saveData = (): void => {
        const sortedAndFilteredItems = getSortedAndFilteredItems(watermarkRuleItems, filters);
        const itemsToDisplay = getBatch(sortedAndFilteredItems, filters.pageSize, filters.page);

        setTotalItems(sortedAndFilteredItems.length);
        setItems(itemsToDisplay);
    };

    return {
        items,
        totalItems,
        isLoading,
        filters,
        saveData
    };
};

const getSortedAndFilteredItems = (items: WatermarkRuleItem[], filters: WatermarkRuleListingFilters) => {
    const sortedItems = getSortedCollection(items, filters.sortBy, filters.sortOrder);

    return filterItems(sortedItems, filters.airlineName ?? "");
};

const filterItems = (items: WatermarkRuleItem[], name: string) => items.filter((item) => matchQuery(item.value, name));
